import { render, staticRenderFns } from "./TableListSubCabang.vue?vue&type=template&id=3b0ab257&scoped=true&"
import script from "./TableListSubCabang.vue?vue&type=script&lang=js&"
export * from "./TableListSubCabang.vue?vue&type=script&lang=js&"
import style0 from "./TableListSubCabang.vue?vue&type=style&index=0&id=3b0ab257&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0ab257",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VDialog,VIcon,VRow,VTextField})
